define('SC.GlobalConfiguration.1.0.0.GlobalConfiguration', [
    'underscore',
    'SC.Configuration',
    'jQuery'
], function HashtagGallery(
    _,
    Configuration,
    jQuery // eslint-disable-line no-unused-vars
) {
    'use strict';

    return {
        mountToApp: function mountToApp(application) {
            var layout = application.getComponent('Layout');
            var pdp = application.getComponent('PDP');
            var configuration = Configuration.get('globalConfiguration');

            /* no myaccount because is no component */
            /* no removing myaccount qoute for now */


            // if (configuration.isHideRequestQoute) {
            //     _.delay(function() {
            //         jQuery('[name="quotes"]').remove();
            //     },1000);
            // }

            if (layout) {
                layout.on('beforeShowContent', function afterShowContent() {
                    (configuration.isHideQuickOrder) ? layout.removeChildView(layout.ALL_VIEWS, 'QuickOrderHeaderLink', 'QuickOrderHeaderLink') : '';
                    (configuration.isHideRequestQoute) ? layout.removeChildView(layout.ALL_VIEWS, 'RequestQuoteWizardHeaderLink', 'RequestQuoteWizardHeaderLink') : '';
                });

                // layout.on('afterShowContent', function() {
                //     (configuration.isHideRequestQoute) ? jQuery('[data-id="quotes"]').remove() : '';
                // })
            }

            if (pdp) {
                pdp.on('beforeShowContent', function afterShowContent() {
                    if (configuration.isHideRequestQoute) {
                        pdp.removeChildView(pdp.PDP_FULL_VIEW, 'ProductDetails.AddToQuote', 'ProductDetails.AddToQuote');
                        pdp.removeChildView(pdp.PDP_QUICK_VIEW, 'ProductDetails.AddToQuote', 'ProductDetails.AddToQuote');
                    }
                });
            }
        }
    };
});
